module.exports = __webpack_public_path__ + "img/enviar.7996827c.svg";